import * as React from 'react';
import * as styles from './Tag.css';

export interface ITagProps {
  text: string;
}

export const Tag: React.FC<ITagProps> = ({ text }) => {
  return <span className={styles['tag']}>{text}</span>;
};
